import { Link } from "react-router-dom";

function ClosingPage({
  title,
  description,
  ctas = [],
  image = "tf_closing_image.svg",
  imageAlt = "",
  imagePosition = "left",
  containerClasses = "",
}) {
  return (
    <section
      className={`closing-tf-landing ${
        imagePosition === "right" ? "image-right" : ""
      } ${containerClasses}`}
    >
      <div className="closing-tf-image">
        <img src={`${process.env.PUBLIC_URL}/images/${image}`} alt={imageAlt} />
      </div>

      <div className="closing-tf-content">
        <div className="closing-tf-title-container">
          <h2 className="white-heading closing-tf-title">{title}</h2>
          <p>{description}</p>
        </div>

        <div className="closing-tf-cta-container">
          {ctas.map((cta, index) => {
            if (!cta.text || !cta.link) return null;

            const buttonType =
              cta.type || (index === 0 ? "primary_light" : "secondary");

            return (
              <Link
                key={`${cta.text}-${cta.link}`}
                to={cta.link}
                className={`cta-button ${buttonType}`}
              >
                {cta.text}
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default ClosingPage;
